import { Component, Input, inject } from '@angular/core';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { CurrencyPipe } from '@angular/common';
import { NgbRating } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-task-estimated-value',
    templateUrl: './task-estimated-value.component.html',
    styleUrls: ['./task-estimated-value.component.scss'],
    imports: [NgbRating, CurrencyPipe]
})
export class TaskEstimatedValueComponent {
  private authService = inject(AuthenticationService);

  @Input() value: number;
  @Input() rank: number;


  public get displayRank() {
    return !(this.authService.isInternalConsultantUser || this.authService.isCaptureAdminUser);
  }
}
